import React, { useState } from "react";
import { Link } from "react-router-dom";
import Grocery from "./ProductsList/Grocery";
import Fashion from "./ProductsList/Fashion";
import Mobile from "./ProductsList/Mobile";
import Curosel from "./Curosel";
import HomeNav from "./HomeNav";
import Television from "./ProductsList/Television";
import HomeAppliances from "./ProductsList/HomeAppliances";
import Footer from "./Footer";
import AllHomeAppliances from "./ProductsList/AllHomeAppliances";
import AllMobile from "./ProductsList/AllMobile";
import AllTelevision from "./ProductsList/AllTelevision";
export default function Home() {
  return (
    <div>
      <div className="home">
        <div className="container-fluid">
          <HomeNav />
          <Curosel />
          <div className="home-grocery mt-2">
            <div className="row">
              <div className="col">
                <h4>Grocery</h4>
                <h6>Deals of the Day</h6>
              </div>
              <div className="col text-right as">
                <Link
                  to={{ pathname: `/AllGrocery`, values: "Grocery" }}
                  className="viewall"
                >
                  View All
                </Link>
              </div>
            </div>
            <hr />
            <div className="row">
              <Grocery />
            </div>
          </div>

          <div className="deal1 mt-3 mb-3">
            <div className="row">
              <div className="col-md-4">
                <Link>
                  <img className="img-fluid" src="./images/Deal1.jpg" alt="" />
                </Link>
              </div>
              <div className="col-md-4">
                <Link>
                  <img className="img-fluid" src="./images/Deal2.jpg" alt="" />
                </Link>
              </div>
              <div className="col-md-4">
                <Link>
                  <img className="img-fluid" src="./images/Deal3.jpg" alt="" />
                </Link>
              </div>
            </div>
          </div>

          <div className="home-grocery mt-2">
            <div className="row">
              <div className="col">
                <h4>Fashion</h4>
                <h6>Deals of the Day</h6>
              </div>
              <div className="col text-right as">
                <Link
                  to={{ pathname: `/AllFashion`, values: "Fashion" }}
                  className="viewall"
                >
                  View All
                </Link>
              </div>
            </div>
            <hr />
            <div className="row">
              <Fashion />
            </div>
          </div>

          <div className="home-grocery mt-2">
            <div className="row">
              <div className="col">
                <h4>Mobile</h4>
                <h6>Deals of the Day</h6>
              </div>
              <div className="col text-right as">
                <Link to="/AllMobile" className="viewall">
                  View All
                </Link>
              </div>
            </div>
            <hr />
            <div className="row">
              <Mobile />
            </div>
          </div>

          <div className="deal1 mt-3 mb-3">
            <div className="row">
              <div className="col-md-4">
                <Link>
                  <img className="img-fluid" src="./images/Deal1.jpg" alt="" />
                </Link>
              </div>
              <div className="col-md-4">
                <Link>
                  <img className="img-fluid" src="./images/Deal2.jpg" alt="" />
                </Link>
              </div>
              <div className="col-md-4">
                <Link>
                  <img className="img-fluid" src="./images/Deal3.jpg" alt="" />
                </Link>
              </div>
            </div>
          </div>

          <div className="home-grocery mt-2">
            <div className="row">
              <div className="col">
                <h4>Television</h4>
                <h6>Deals of the Day</h6>
              </div>
              <div className="col text-right as">
                <Link to="/AllTelevision" className="viewall">
                  View All
                </Link>
              </div>
            </div>
            <hr />
            <div className="row">
              <Television />
            </div>
          </div>

          <div className="home-grocery mt-2">
            <div className="row">
              <div className="col">
                <h4>Home Appliances</h4>
                <h6>Deals of the Day</h6>
              </div>
              <div className="col text-right as">
                <Link to="/AllHomeAppliances" className="viewall">
                  View All
                </Link>
              </div>
            </div>
            <hr />
            <div className="row">
              <HomeAppliances />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
